import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import { reducer } from './reducers';

const composeEnhancer = compose;

export const store = createStore(
    reducer,
    composeEnhancer(applyMiddleware(thunk))
)

